import React, { useState, useEffect, useContext } from 'react';
import {
  Row,
  Col,
  Modal,
  Form,
  Alert,
  Button
} from 'react-bootstrap';
import {Uploader} from '../../components';
import _ from 'lodash';
import Utils from '../../Utils';

const AskTitle = (props) => {
  const logosize_in_mb =  _.get(process.env,'REACT_APP_MAX_LOGO_SIZE',1);  
  const [sprops,setSprops] = useState(_.get(props,'data.sprops', {title: '',photo:'',pass_score: ''}));
  const [errMsg,setErrMsg] = useState('');

  const onUploadPhoto = (attr,status) => {    
    if(status==='error_file_size'){
      setErrMsg(`You have uploaded ${(attr.meta.size/1024/1024).toFixed(1)} MB file, however, 
      the acceptable maximum file size is ${logosize_in_mb} MB. Try again with an acceptable sized file.`);
    }else{
      setErrMsg('');
      setSprops({...sprops, photo : attr});   
    } 
  }

  const removeImageHandler = () => {
    if(window.confirm("Are you sure to remove logo?")){
      setSprops({...sprops, photo:''});
    }
  }

  const onSpropsSubmit = (e) => {
    const frm = e.currentTarget;
    e.preventDefault();
    if(frm.title.value===""){
      window.alert('Please fill title!');
      frm.title.focus();
    }else if(_.get(props,'countable',false) && (parseFloat(frm.pass_score.value) < 0 || parseFloat(frm.pass_score.value) >100)){
      window.alert("Please enter a value from 0 to 100 as pass score value for this scorm");
      frm.pass_score.focus();
    }else{
      let objVal = {...sprops,title:frm.title.value, pass_score: 0};
      if(props.countable){
        objVal['pass_score']= frm.pass_score.value;
      }
      props.onSuccess(objVal);
    }
  }

  return <Modal
      show={true}
      onHide={props.onHide}
      backdrop="static"
      keyboard={false}
      size='md'
    >
      <Modal.Header closeButton className="setPropPopHeader">
        <Modal.Title>Set Properties for SCORM Course</Modal.Title>
        </Modal.Header>
      <Form onSubmit={onSpropsSubmit}  className="setPropPopForm">
        <Modal.Body>
          <Row>
            <Col className="col-4">Your Brand Name</Col>
            <Col><Form.Control type="text" className="mb-3" name="title" defaultValue={sprops.title} placeholder="Enter your Course name" /></Col>
          </Row>
          {_.get(props,'countable',false) && <Row>
            <Col sm={6}><Form.Label>Set the Pass percentage for this course</Form.Label></Col>
            <Col><Form.Control type="text" className="mb-3" name="pass_score" defaultValue={_.get(sprops,'pass_score',100)} placeholder="Score percentage" /></Col>
          </Row>}
          
          <Row>
            <Col className="col-4">Your Brand Logo</Col>
            <Col className="smimg"><img src={`${process.env.PUBLIC_URL}/images/Image-Icon.png`} alt="LOGO" /></Col>
          </Row>

          { sprops.photo === '' && <Row className="mt-3">
            <Col className="text-left" style={{minHeight: '200px', maxHeight: '300px'}}>
              <Uploader 
              instructions={`To upload your logo (max allowed ${logosize_in_mb} MB), click here or drag/drop your logo here`}
              accept="image/*" 
              maxSizeBytes={logosize_in_mb*1024*1024} 
              uploadUrl={Utils.apiUrl('saveupload')} 
              onUpload={onUploadPhoto} />
            </Col>    
          </Row> }
          {sprops.photo && <Row className="mt-3">
            <Col className="text-center" style={{minHeight:'200px', maxHeight:'auto'}}>
            <div className="logoContainer mb-3">
              <img  src={Utils.apiUrl(`image?f=${sprops.photo}`)} alt="logo" className="scormLogo"/>
              <img src={`${process.env.PUBLIC_URL}/images/minus_circle_icon.png`} className="text-right scormRemove" onClick={removeImageHandler} alt="Remove" />
            </div>                                    
          </Col>
          </Row>} 
          {console.log((sprops.photo), "sprops")}
          {errMsg !== '' && <>
          <Alert variant="danger" className="p-3"><i className="fa fa-exclamation-circle" />  {errMsg} </Alert>
          </>}
        </Modal.Body>
        <Modal.Footer>          
          <Button type="submit" className="active px-5 py-2 float-right">Continue</Button>
        </Modal.Footer>
      </Form>
    </Modal>
}

export default AskTitle;